<template>
  <list mode="prediction" :items="predictions" @load="onLoad" @delete="onDelete" />
</template>

<script>
import List from "@/components/list"
import Predictions from "@/api/predictions"
export default {
  name: "Predictions",
  components: { List },
  data() {
    return {
      predictions: {
        limit: 20,
        offset: 0,
        count: 0,
        results: []
      }
    }
  },
  methods: {
    onLoad() {
      if (this.predictions.count == 0 || this.predictions.offset < this.predictions.count) {
        this.setBusy(true)
        Predictions.list(this.predictions.offset).then(response => {
          this.predictions.count = response.data.count
          this.predictions.results.push(...response.data.results)
          this.predictions.offset += this.predictions.limit
        }).finally(() => this.setBusy(false))
      }
    },
    onDelete(items) {
      Predictions.delete({ items: items }).then(response => {
        this.notify(response.data)
        this.refresh()
      })
    }
  }
}
</script>